module.exports = __webpack_public_path__ + "media/images/btn_update_booking-9034659232ec95829132498eb83632af.gif";